import { render, staticRenderFns } from "./LmProcessNewOrEdit-2.vue?vue&type=template&id=d883364e&scoped=true"
import script from "./LmProcessNewOrEdit-2.vue?vue&type=script&lang=js"
export * from "./LmProcessNewOrEdit-2.vue?vue&type=script&lang=js"
import style0 from "./LmProcessNewOrEdit-2.vue?vue&type=style&index=0&id=d883364e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d883364e",
  null
  
)

export default component.exports